import { Controller } from "@hotwired/stimulus";

// Lightweight, honest cookie notice. The site uses only essential cookies and
// cookieless analytics, so there is nothing to gate — this is an acknowledgement,
// not a consent gate. We remember dismissal in localStorage so it shows once.
export default class extends Controller {
  static values = { storageKey: { type: String, default: "auditbadger:cookie-notice" } };

  connect() {
    // ?show_cookie_notice=1 clears the stored dismissal so the notice can be
    // re-tested (development) or re-surfaced for a visitor (support).
    if (new URLSearchParams(window.location.search).has("show_cookie_notice")) {
      try {
        localStorage.removeItem(this.storageKeyValue);
      } catch (_) {
        // localStorage may be unavailable; the notice shows regardless.
      }
    }

    if (this.isDismissed()) {
      this.element.remove();
      return;
    }

    // Reveal on the next frames so it eases in rather than flashing on first paint.
    this.element.classList.remove("hidden");
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.element.classList.remove("opacity-0", "translate-y-4");
      });
    });
  }

  dismiss() {
    try {
      localStorage.setItem(this.storageKeyValue, "1");
    } catch (_) {
      // localStorage may be unavailable (private mode); fail quietly.
    }

    this.element.classList.add("opacity-0", "translate-y-4");
    setTimeout(() => this.element.remove(), 250);
  }

  isDismissed() {
    try {
      return localStorage.getItem(this.storageKeyValue) === "1";
    } catch (_) {
      return false;
    }
  }
}
